export function hasClientQuestionnaireSubmission(form = {}) {
  return Boolean(
    form.objectif_primaire
    || form.dureeProbleme
    || form.ressentiDigestion,
  );
}

export function isClientAppEffectivelyActive(client = {}) {
  const form = client.form || {};
  const journey = client.journey_state || {};
  const questionnaireThroughApp = journey.questionnaire_mode === 'app'
    && hasClientQuestionnaireSubmission(form);

  return Boolean(
    client.app_enabled
    || client.staging_client_id
    || client.stagingClientId
    || questionnaireThroughApp,
  );
}

/**
 * Autorite unique du canal app pour le parcours courant.
 *
 * Une remise document-only prime sur toute ancienne identite app encore
 * presente sur la fiche. Les preuves de livraison app explicites restent
 * prioritaires ; les anciens dossiers sans preuve conservent le comportement
 * historique base sur l'activation effective.
 */
export function isClientAppChannelEnabled(client = {}, journey = client?.journey_state || {}) {
  const deliveryMode = journey?.delivery_proof?.mode;
  if (deliveryMode === 'document') return false;
  if (deliveryMode === 'app' || deliveryMode === 'app_and_document') return true;
  return isClientAppEffectivelyActive(client);
}
